<script setup>
defineProps({
  width: { type: [Number, String], default: 44 },
  height: { type: [Number, String], default: 20 }
})
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 44 20" role="img" aria-label="OPERA">
    <text
      x="0" y="16" font-family="Segoe UI, PingFang SC, sans-serif"
      font-size="18" font-weight="600" fill="currentColor" letter-spacing=".5"
    ></text>
  </svg>
</template>
